
/* eslint-disable */
<template>
  <div id="app">
    <MainSpinnerPanel />
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MainSpinnerPanel from "./components/common/MainSpinnerPanel";
import WarningImplementation from "./components/common/WarningImplementation";
import {
  REPARTO_NAME,
  PROJECT_NAME,
  META_KEYWORDS,
  META_THUMBNAIL,
  META_DESCRIPTION,
  META_AUTHOR,
  META_COPYRIGHT,
  META_OG_TITLE,
  META_OG_IMAGE,
  META_OG_TYPE,
  META_OG_DESCRIPTION,
  META_OG_URL,
  FB_DOMAIN_VERIFICATION,
  FB_PIXEL_TAG,
  GOOGLE_ANALYTICS_CODE,
  IUBENDA_CONFIG,
} from "./utils/config";
import Vue from "vue";
import VueAnalytics from "vue-analytics";

/* eslint-disable */

const iubendaCookieManager = (config) => {
  return new Promise((resolve, reject) => {
    _iub.csConfiguration = {
      floatingPreferencesButtonDisplay: "bottom-right",
      perPurposeConsent: true,
      siteId: 2967828,
      whitelabel: false,
      cookiePolicyId: 62165040,
      lang: "it",
      banner: {
        acceptButtonCaptionColor: "#000000",
        acceptButtonColor: "#FFFFFF",
        acceptButtonDisplay: true,
        backgroundColor: "#4673B5",
        closeButtonDisplay: false,
        customizeButtonDisplay: true,
        explicitWithdrawal: true,
        listPurposes: true,
        position: "bottom",
        rejectButtonCaptionColor: "#000000",
        rejectButtonColor: "#FFFFFF",
        rejectButtonDisplay: true,
      },
      callback: {
        onPreferenceExpressed: function (preference) {
          fbtag(FB_PIXEL_TAG);
          enableAnalitics(GOOGLE_ANALYTICS_CODE);
        },
      },
    };

    let script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.charset = "UTF-8";
    script2.async = true;
    script2.src = "https://cdn.iubenda.com/cs/iubenda_cs.js";
    document.head.appendChild(script2);
  });
};

const enableAnalitics = (idAnalytics) => {
  Vue.use(VueAnalytics, {
    id: idAnalytics,
    trackEvent: true,
  });
};
/* eslint-disable */
const fbtag = (pixeltag) => {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  fbq("init", pixeltag);
  fbq("track", "PageView");
};
/* eslint-enable */

export default {
  name: "App",
  components: { WarningImplementation, MainSpinnerPanel },
  metaInfo: {
    title: PROJECT_NAME,
    titleTemplate: `${REPARTO_NAME} - Flexy %s`,
    meta: [
      { charset: "utf-8" },
      { name: "description", content: "gator" },
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0",
      },
      { name: "keywords", content: META_KEYWORDS },
      { name: "thumbnail", content: META_THUMBNAIL },
      { name: "description", content: META_DESCRIPTION },
      { name: "author", content: META_AUTHOR },
      { name: "copyright", content: META_COPYRIGHT },
      { name: "og:title", content: META_OG_TITLE },
      { name: "og:image", content: META_OG_IMAGE },
      { name: "og:type", content: META_OG_TYPE },
      { name: "og:description", content: META_OG_DESCRIPTION },
      { name: "og:url", content: META_OG_URL },
      { name: "facebook-domain-verification", content: FB_DOMAIN_VERIFICATION },
      { name: "pixeltag", content: FB_PIXEL_TAG },
    ],
  },
  methods: {
    ...mapActions(["normalizeDates"]),
    storageNormalizeDate() {
      if (window.sessionStorage.vuex) {
        this.normalizeDates();
      }
    },
  },
  beforeMount() {},
  created() {
    iubendaCookieManager(IUBENDA_CONFIG);
    this.storageNormalizeDate();
  },
};
</script>

  <noscript>
    <img height="1" width="1" src="https://www.facebook.com/tr?id=2628661370515362&ev=PageView
      &noscript=1" />
  </noscript>



// WEBPACK FOOTER //
// src/front/App.vue